<template>
    <div id="andonType" style="width: 100%; height: 75%"></div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    shopInfo: {
      type: Object,
      default: ''
    }
  },
  data () {
    return {
      andonStateBeg: {
        fcCode: '',  //工厂
        shopCode: '',   //车间
        sectionCode: '',   //工段
        lineCode: ''    //产线
      },
      andonStateInfo: [],
      andonTypesafety: 0,
      andonTypefacility: 0,
      andonTypelogistics: 0,
      andonTypequality: 0,
      andonTypes: [],
      andonTypeNames: [],
      listName: [],
      listInfo: [],
    }
  },
  watch: {
    shopInfo: {
      handler (val) {
        this.andonStateBeg.fcCode = val.fcCode
        this.andonStateBeg.shopCode = val.shopCode
        this.andonStateBeg.sectionCode = val.sectionCode
        this.andonStateBeg.lineCode = val.lineCode
        this.lineState()
      },
      deep: true
    }
  },
  mounted () {
      if (window.sessionStorage.getItem('userInfo')) {
          let userInfo = JSON.parse(window.sessionStorage.getItem('userInfo'))
          if (userInfo.factoryId == 0) {
              this.lineState()
          }
      }
  },
  methods: {
    //安灯类型
    lineState () {
      console.log(this.andonStateBeg)
      let options = {
        method: 'GET',
        url: this.$api.andonStateecharts,
        params: this.andonStateBeg
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.andonStateInfo = response.data.andonTypeList
          console.log(response.data.andonTypeList)
          let listName = []
          let listInfo = []
          if (this.andonStateInfo) {
            for (let i = 0;i < this.andonStateInfo.length;i++) {
              listName.push(this.andonStateInfo[i].atName)
              listInfo.push(this.andonStateInfo[i].andonTypeCount)
            }
            this.listName = listName
            this.listInfo = listInfo
          }
          //   if (this.andonStateInfo) {
          //     /*for (let i = 0; i < this.andonStateInfo.length; i++) {
          //         if (this.andonStateInfo[i].atName == '安全') {
          //             this.andonTypesafety = this.andonStateInfo[i].andonTypeCount
          //         } else if (this.andonStateInfo[i].atName == '设备') {
          //             this.andonTypefacility = this.andonStateInfo[i].andonTypeCount
          //         } else if (this.andonStateInfo[i].atName == '物流') {
          //             this.andonTypelogistics = this.andonStateInfo[i].andonTypeCount
          //         } else if (this.andonStateInfo[i].atName == '质量') {
          //             this.andonTypequality = this.andonStateInfo[i].andonTypeCount
          //         }
          //     }*/
          //     for (let i = 0;i < this.andonStateInfo.length;i++) {
          //       let array = {
          //         name: '',
          //         value: ''
          //       }
          //       array.name = this.andonStateInfo[i].atName
          //       array.value = this.andonStateInfo[i].andonTypeCount
          //       this.andonTypeNames.push(this.andonStateInfo[i].atName)
          //       this.andonTypes.push(array)
          //     }
          //   } else {
          //     /*this.andonTypesafety = 0
          //     this.andonTypefacility = 0
          //     this.andonTypelogistics = 0
          //     this.andonTypequality = 0*/
          //     this.andonTypes = []
          //     this.andonTypeNames = []
          //   }
          this.andonTypeechar()
        } else {
          this.$message.error('请求失败！')
        }
      })
    },
    //设备状态柱形图
    andonTypeechar () {
      var self = this
      var chartDom = document.getElementById('andonType')
      var myChart = echarts.init(chartDom)
      window.addEventListener('resize', () => {
        myChart.resize()
      })
      var option
      //整条柱形的点击事件
      /*myChart.on('click', function (params) {
        let array = {}
        let andonTypes = params.name
        if (self.andonStateBeg.fcCode != undefined && self.andonStateBeg.fcCode != '') {
          array['fcCode'] = self.andonStateBeg.fcCode
        }
        if (self.andonStateBeg.shopCode != undefined && self.andonStateBeg.shopCode != '') {
          array['shopCode'] = self.andonStateBeg.shopCode
        }
        if (self.andonStateBeg.sectionCode != undefined && self.andonStateBeg.sectionCode != '') {
          array['sectionCode'] = self.andonStateBeg.sectionCode
        }
        if (self.andonStateBeg.lineCode != undefined && self.andonStateBeg.lineCode != '') {
          array['lineCode'] = self.andonStateBeg.lineCode
        }
        if (andonTypes != '') {
          array['andonTypes'] = andonTypes
        }
        self.$router.push({
          name: 'acoustoSpectaculars',
          params: {
            andonState: array
          }
        })
      })*/
      var xData = this.listName
      var yData = this.listInfo
      option = {
        'grid': {
          'top': '25%',
          'left': '-5%',
          'bottom': '5%',
          'right': '5%',
          'containLabel': true
        },
        tooltip: {
          show: true
          //   trigger: 'axis',
          //   axisPointer: {
          //     type: 'shadow'
          //   },
          //   textStyle: {
          //     color: '#999',
          //     align: 'left'
          //   },
          //   position: ['30%', '30%'],
          //   extraCssText:
          //     'box-shadow:0px 0px 8px 0px rgba(176,176,176,1)',
          //   backgroundColor: '#fff',
          //   formatter: function (params) {
          //     console.log(params)
          //     //去除重复数据
          //     for (var i = 0;i < params.length;i++) {
          //       for (var j = params.length - 1;j > i;j--) {
          //         if (
          //           params[j].seriesName == params[i].seriesName
          //         ) {
          //           params.splice(j, 1)
          //           break
          //         }
          //       }
          //     }
          //     var res = ''
          //     console.log(params)
          //     var data = '<p>' + params[0].name + '</p >'
          //     res += '<p>' + params[0].value + '</p >'
          //     return data + res
          //   }
        },
        animation: false,
        'xAxis': [{
          'type': 'category',
          'data': xData,
          'axisTick': {
            'alignWithLabel': true
          },
          'nameTextStyle': {
            'color': '#82b0ec'
          },
          'axisLine': {
            show: false,
            'lineStyle': {
              'color': '#82b0ec'
            }
          },
          'axisLabel': {
            interval: 0,
            'textStyle': {
              'color': '#fff'
            },
            margin: 30
          }
        }],
        'yAxis': [{
          show: false,
          'type': 'value',
          'axisLabel': {
            interval: 0,
            'textStyle': {
              'color': '#fff'
            }
          },
          'splitLine': {
            'lineStyle': {
              'color': '#0c2c5a'
            }
          },
          'axisLine': {
            'show': false
          }
        }],
        'series': [{
          'name': '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, -6],
          symbolPosition: 'end',
          z: 12,
          // "barWidth": "0",
          'label': {
            'normal': {
              'show': true,
              'position': 'top',
              // "formatter": "{c}%"
              fontSize: 15,
              fontWeight: 'bold',
              color: '#5bfcf4'
            }
          },
          color: '#5bfcf4',
          data: yData
        },
        {
          name: '',
          type: 'pictorialBar',
          symbolSize: [20, 10],
          symbolOffset: [0, 7],
          // "barWidth": "20",
          z: 12,
          'color': '#5bfcf4',
          'data': yData
        },
        // {
        //   name: '',
        //   type: 'pictorialBar',
        //   symbolSize: [30, 15],
        //   symbolOffset: [0, 15],
        //   z: 10,
        //   itemStyle: {
        //     normal: {
        //       color: 'transparent',
        //       borderColor: '#ff2323',
        //       borderType: 'solid',
        //       borderWidth: 10
        //     }
        //   },
        //   data: yData
        // },
        // {
        //   name: '',
        //   type: 'pictorialBar',
        //   symbolSize: [40, 20],
        //   symbolOffset: [0, 18],
        //   z: 10,
        //   itemStyle: {
        //     normal: {
        //       color: 'transparent',
        //       borderColor: '#ff2323',
        //       borderType: 'solid',
        //       borderWidth: 8
        //     }
        //   },
        //   data: yData
        // },
        {
          type: 'bar',
          //silent: true,
          'barWidth': '20',
          barGap: '10%', // Make series be overlap
          barCateGoryGap: '10%',
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 0.7, [{
                offset: 0,
                color: '#38B2E6'
              },
              {
                offset: 1,
                color: '#0B3147'
              }
              ]),
              opacity: .8
            }
          },
          data: yData
        }
        ]
      }
      option && myChart.setOption(option)
    }
  }
}
</script>

<style>
</style>
